export default __webpack_public_path__ + "static/media/aimikel_avatar.74dcfa56.png";